window.addEventListener('DOMContentLoaded', () => {
  const mobileDrawers = [...document.querySelectorAll('.footer__main__navigation > ul > li')];
  const mobileDrawerLinks = [
    ...document.querySelectorAll('.footer__main__navigation > ul > li > .menu-item-title'),
  ];
  const mediaQueryDesktop = matchMedia('(min-width: 1024px)');

  // Handle drawers.
  if (mobileDrawerLinks.length > 0) {
    mobileDrawerLinks.forEach((mobileDrawerLink) => {
      mobileDrawerLink.addEventListener('click', (event) => {
        event.preventDefault();
        mobileDrawerLink.parentElement.classList.toggle('menu-item--open');
      });
    });
  }

  // Handle window resize
  mediaQueryDesktop.addEventListener('change', (event) => {
    mobileDrawers.forEach((mobileDrawer) => {
      if (event.matches && mobileDrawer.classList.contains('menu-item--open')) {
        mobileDrawer.classList.remove('menu-item--open');
      }
    });
  });
});
